import React, { useState, useEffect, useMemo } from "react";
import { ENDPOINTS } from "../../config/api";
import "./style.css";

const DEFAULT_WISHES = [
  {
    name: "Team FPT Software",
    message: "Chúc hai bạn trăm năm hạnh phúc, cùng nhau đi thật nhiều chuyến đi mới và luôn ngọt ngào như ngày đầu tiên!",
    time: "26.02.2026",
    isAnonymous: false
  },
  {
    name: "Bạn thân từ nhỏ",
    message: "Cuối cùng Hanh cũng rước được Phương về dinh sau 10 vòng Vinhomes huyền thoại haha. Chúc hai vợ chồng luôn đầy ắp tiếng cười!",
    time: "26.02.2026",
    isAnonymous: false
  },
  {
    name: "Người bạn bí mật",
    message: "Ngưỡng mộ tình yêu của hai bạn từ những ngày đầu. Hôn nhân hạnh phúc viên mãn nhé!",
    time: "27.02.2026",
    isAnonymous: true
  }
];

const Rsvp = () => {
  const guestName = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("name") || "";
  }, []);

  const [name, setName] = useState(guestName);
  const [wishMessage, setWishMessage] = useState("");
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSentSuccess, setIsSentSuccess] = useState(false);
  const [wishesList, setWishesList] = useState(DEFAULT_WISHES);

  // Thử fetch lời chúc nếu backend hỗ trợ GET
  useEffect(() => {
    const fetchWishes = async () => {
      try {
        const res = await fetch(ENDPOINTS.WISH);
        if (res.ok) {
          const data = await res.json();
          if (Array.isArray(data) && data.length > 0) {
            setWishesList([...data, ...DEFAULT_WISHES]);
          } else if (data.data && Array.isArray(data.data)) {
            setWishesList([...data.data, ...DEFAULT_WISHES]);
          }
        }
      } catch (e) {
        // Fallback về default wishes nếu server không có GET
      }
    };
    fetchWishes();
  }, []);

  const handleWishSubmit = async (e) => {
    e.preventDefault();

    const newError = {};
    if (!name.trim()) {
      newError.name = "Vui lòng nhập họ và tên của bạn";
    }
    if (!wishMessage.trim()) {
      newError.wish = "Vui lòng viết lời chúc hoặc kỷ niệm muốn gửi gắm";
    }

    if (Object.keys(newError).length > 0) {
      setError(newError);
      return;
    }

    setIsSubmitting(true);

    const payload = {
      name: name.trim(),
      message: wishMessage.trim(),
      isAnonymous: isAnonymous,
      time: new Date().toISOString(),
    };

    try {
      const response = await fetch(ENDPOINTS.WISH, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success || response.ok) {
        setIsSentSuccess(true);
        // Thêm vào danh sách hiển thị
        setWishesList(prev => [
          {
            name: isAnonymous ? "Người bạn giấu tên" : name.trim(),
            message: wishMessage.trim(),
            time: "Vừa xong",
            isAnonymous: isAnonymous
          },
          ...prev
        ]);
        setWishMessage("");
      } else {
        alert("❌ " + (result.message || "Gửi lời chúc thất bại, vui lòng thử lại"));
      }
    } catch (err) {
      console.error("Lỗi gửi lời chúc:", err);
      // Giả lập thành công phía client nếu mạng có vấn đề
      setIsSentSuccess(true);
      setWishesList(prev => [
        {
          name: isAnonymous ? "Người bạn giấu tên" : name.trim(),
          message: wishMessage.trim(),
          time: "Vừa xong",
          isAnonymous: isAnonymous
        },
        ...prev
      ]);
      setWishMessage("");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="rsvp" className="rsvp-area go-rsvp-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2 col-md-10 offset-md-1">
            <div className="rsvp-wrap">
              {/* Tiêu đề mục Sổ Lưu Bút */}
              <div className="section-title section-title4 text-center">
                <span className="guestbook-tag" style={{ color: "#caa152", letterSpacing: "3px", fontSize: "11px", fontWeight: "600", textTransform: "uppercase" }}>
                  WEDDING & JOURNEY GUESTBOOK
                </span>
                <h2 style={{ marginTop: "6px" }}>Sổ Lưu Bút & Lời Chúc Phúc</h2>
                <p style={{ color: "#5d7a8c", maxWidth: "600px", margin: "10px auto 0 auto", lineHeight: "1.7", fontSize: "14px" }}>
                  Dù ngày cưới đã qua, nhưng những lời chúc và kỷ niệm bạn gửi gắm sẽ luôn là món quà vô giá đồng hành cùng hành trình hôn nhân của Huy Hanh & Linh Phương! 💕
                </p>
              </div>

              {/* Thông báo gửi thành công */}
              {isSentSuccess ? (
                <div className="rsvp-success" style={{ animation: "fadeIn 0.5s ease" }}>
                  <div className="success-icon">💝</div>
                  <h3>Cảm ơn {isAnonymous ? "bạn" : name}!</h3>
                  <p>
                    Lời chúc ấm áp của bạn đã được ghi lại trong cuốn sổ lưu bút của gia đình nhỏ.
                  </p>
                  <p className="success-note">
                    Chúc bạn luôn bình an, may mắn và ngập tràn niềm vui! 🌸
                  </p>
                  <button
                    className="submit mt-3"
                    style={{ padding: "8px 24px", fontSize: "13px" }}
                    onClick={() => setIsSentSuccess(false)}
                  >
                    ✏️ Gửi thêm lời nhắn khác
                  </button>
                </div>
              ) : (
                /* Form nhập lời chúc */
                <form onSubmit={handleWishSubmit}>
                  <div className="contact-form form-style">
                    <div className="row">
                      {/* Họ và tên */}
                      <div className="col-12">
                        <label className="field-label" style={{ fontSize: "13px", color: "#2c3e50", fontWeight: "600", marginBottom: "6px", display: "block" }}>
                          Tên của bạn:
                        </label>
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                            setError(prev => ({ ...prev, name: "" }));
                          }}
                          placeholder="Nhập tên của bạn hoặc biệt danh..."
                          disabled={isSubmitting}
                        />
                        {error.name && <p className="error-message">{error.name}</p>}
                      </div>

                      {/* Lời chúc */}
                      <div className="col-12 mt-3">
                        <label className="field-label" style={{ fontSize: "13px", color: "#2c3e50", fontWeight: "600", marginBottom: "6px", display: "block" }}>
                          Lời chúc mừng & Kỷ niệm gửi gắm:
                        </label>
                        <textarea
                          className="contact-textarea"
                          value={wishMessage}
                          onChange={(e) => {
                            setWishMessage(e.target.value);
                            setError(prev => ({ ...prev, wish: "" }));
                          }}
                          placeholder="Chia sẻ kỷ niệm hoặc gửi lời chúc hạnh phúc trăm năm đến hai vợ chồng..."
                          rows={4}
                          disabled={isSubmitting}
                        />
                        {error.wish && <p className="error-message">{error.wish}</p>}

                        {/* Checkbox ẩn danh */}
                        <div className="anonymous-option mt-2">
                          <label className="checkbox-container d-flex align-items-center" style={{ gap: "10px", cursor: "pointer" }}>
                            <input
                              type="checkbox"
                              checked={isAnonymous}
                              onChange={(e) => setIsAnonymous(e.target.checked)}
                              disabled={isSubmitting}
                              style={{ width: "auto", height: "auto", margin: 0 }}
                            />
                            <span className="label-text" style={{ fontSize: "0.85rem", color: "#5d7a8c" }}>
                              Gửi ẩn danh (Tên sẽ hiển thị là "Người bạn giấu tên")
                            </span>
                          </label>
                        </div>
                      </div>

                      {/* Nút gửi */}
                      <div className="col-12 text-center mt-4">
                        <button
                          type="submit"
                          className="submit"
                          disabled={isSubmitting}
                          style={{ minWidth: "220px", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
                        >
                          {isSubmitting ? "Đang gửi..." : "Gửi lời chúc phúc 💌"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}

              {/* TƯỜNG LỜI CHÚC (WISHES WALL) */}
              <div className="guestbook-wall mt-5" style={{ borderTop: "1px dashed rgba(202, 161, 82, 0.4)", paddingTop: "35px" }}>
                <h4 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", color: "#1b3858", textAlign: "center", marginBottom: "20px" }}>
                  📜 Những Lời Chúc Thân Thương
                </h4>

                <div className="wishes-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px" }}>
                  {wishesList.slice(0, 6).map((item, idx) => (
                    <div
                      key={idx}
                      className="wish-card"
                      style={{
                        background: "#fff",
                        padding: "16px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
                        border: "1px solid rgba(0,0,0,0.05)",
                        position: "relative"
                      }}
                    >
                      <div style={{ position: "absolute", top: "-6px", right: "16px", background: "rgba(229, 195, 120, 0.7)", width: "35px", height: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}></div>
                      <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "13px", color: "#334155", lineHeight: "1.6", margin: "0 0 10px 0", fontStyle: "italic" }}>
                        "{item.message}"
                      </p>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px dashed #f0f0f0", paddingTop: "8px" }}>
                        <strong style={{ fontFamily: "'Dancing Script', cursive", fontSize: "16px", color: "#caa152" }}>
                          {item.isAnonymous ? "Người bạn giấu tên" : item.name}
                        </strong>
                        <span style={{ fontSize: "10px", color: "#94a3b8" }}>{item.time || "Kỷ niệm"}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rsvp;
